
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-quotation.do",
      function () {
        return require("private-next-pages/about-quotation.do/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-quotation.do"])
      });
    }
  